import { create } from "zustand";

export const activeLabelBoxWidth = 400;

interface ActiveProductBoxInfo {
  left: number;
  top: number;
  planogram_product_id: string;
  product_id: string;
}

const getInitState = () => {
  return {
    mouseDownUuid: "",
    productBoxInfo: {
      left: 0,
      top: 0,
      planogram_product_id: "",
      product_id: "",
    } as ActiveProductBoxInfo,
  };
};

interface State extends ReturnType<typeof getInitState> {
  setMouseDownUuid: (mouseDownUuid: string) => void;
  setActiveLabelBoxInfo: (productBoxInfo: ActiveProductBoxInfo) => void;
  reset: () => void;
}

export const useActivePlanoProductInfoStore = create<State>()((set) => ({
  ...getInitState(),
  //
  setMouseDownUuid: (mouseDownUuid) => set({ mouseDownUuid }),
  setActiveLabelBoxInfo: (productBoxInfo) =>
    set({ productBoxInfo: productBoxInfo }),
  //
  reset: () => set(getInitState()),
}));
